import { render, staticRenderFns } from "./program.vue?vue&type=template&id=a4c1374a&"
import script from "./program.vue?vue&type=script&lang=js&"
export * from "./program.vue?vue&type=script&lang=js&"
import style0 from "./program.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports